<template>
  <div class="playlist-delete">
    <Modal v-if="open" ref="deleteComfirmForm" class="mk-modal" @close="close">
      <slot>
        <div class="title">
          {{ $t('PLAYLIST.DELETE_PLAYLIST') }}
        </div>
        <div class="desp" v-html="$t('PLAYLIST.DELETE_PLAYLIST_DESP', {playlist: item.title})" />
        <div class="btn-group">
          <a :class="{'loading': formSubmit}" class="mk-btn mk-btn--danger" @click="deleteItem">
            {{ $t('COMMON.DELETE') }}
          </a>
          <a class="mk-btn mk-btn--secondary" @click="close">
            {{ $t('COMMON.CANCEL') }}
          </a>
        </div>
      </slot>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/common/Modal'
import { getLocalStorage } from '@/assets/helpers/UtilHelper'
import PlaylistService from '@/assets/services/PlaylistService'

export default {
  name: 'PlaylistDeleteModal',
  components: {
    Modal
  },
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: Boolean,
      default: false
    },
    desp: {
      type: Object,
      default: () => {}
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      formSubmit: false
    }
  },
  watch: {
    open(val) {
      this.formSubmit = false
    }
  },
  methods: {
    close() {
      // this.$refs.deleteComfirmForm.zoomEnable()
      this.$emit('close')
    },
    async deleteItem() {
      const tokenInLocalStorage = getLocalStorage('token')
      this.formSubmit = true
      await PlaylistService.deletePlaylist(tokenInLocalStorage, this.item.id)
      this.$store.dispatch('UPDATE_USER_FOLLOWING') // Notify user store
      // this.$refs.deleteComfirmForm.zoomEnable()
      this.$emit('close', true)
    }
  }
}

</script>
<style lang="scss" scoped>
@import '@/assets/scss/component/button.scss';
@import '@/assets/scss/component/form.scss';
@import '@/assets/scss/variables.scss';

@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}

</style>
